export default {
  audio: [
    {
      id: 'button-click',
      src: 'assets/audios/button-click.mp3',
    },
    {
      id: 'start-activity',
      src: 'assets/audios/start-activity.mp3',
    },
    {
      id: 'bg-sound',
      src: 'assets/audios/background-sound.mp3',
    },
  ],
  image: [
    {
      id: 'bg-title-screen',
      src: 'assets/images/title-screen.png',
    },
    {
      id: 'bg-card-name',
      src: 'assets/images/card-bg.png',
    },
    {
      id: 'bg-slide-0',
      src: 'assets/images/bg-slide-0.jpg',
    },
    {
      id: 'bg-slide-1',
      src: 'assets/images/bg-slide-1.jpg',
    },
    {
      id: 'bg-slide-2',
      src: 'assets/images/bg-slide-2.jpg',
    },
    {
      id: 'bg-slide-3',
      src: 'assets/images/bg-slide-3.jpg',
    },
    {
      id: 'bg-slide-4',
      src: 'assets/images/bg-slide-4.jpg',
    },
    {
      id: 's1-modal',
      src: 'assets/images/s1-modal.jpg',
    },
    {
      id: 's2-modal',
      src: 'assets/images/s2-modal.jpg',
    },
    {
      id: 's3-modal',
      src: 'assets/images/s3-modal.jpg',
    },
  ],
  video: [
    {
      id: 'vid-slide-0',
      src: 'assets/videos/vid-slide-0.mp4',
    },
  ],
};
